/* Check the current cart before a Premium Box quick-add. */
window.royalPremiumAddQuantity = async function (productId) {
  var response = await fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', { cache: 'no-store' });
  if (!response.ok) throw new Error('Could not check the cart. Please try again.');
  var cart = await response.json();
  return cart.items.some(function (item) { return String(item.product_id) === String(productId); }) ? 5 : 25;
};

document.addEventListener('submit', async function (event) {
  var form = event.target;
  if (!form.matches('form[data-premium-quick-add]') || form.dataset.premiumSubmitting === 'true') return;
  event.preventDefault();
  var button = event.submitter;
  if (button) button.disabled = true;
  try {
    form.elements.quantity.value = await window.royalPremiumAddQuantity(form.dataset.productId);
    form.dataset.premiumSubmitting = 'true';
    form.submit();
  } catch (error) {
    if (button) button.disabled = false;
    alert(error.message || 'Could not check the cart. Please try again.');
  }
});
